module.exports = __webpack_public_path__ + "img/credito_cancelado.4134e92c.png";